import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import { Cell, Grid } from 'react-md'

import { TextField } from 'components'
import { required, minLength, maxLength } from 'lib/validation'

const minLength6 = minLength(6)
const maxLength50 = maxLength(50)

const validate = values => {
  const errors = {}

  if (values.newPassword !== values.confirmNewPassword) {
    errors.confirmNewPassword = 'These passwords don\'t match'
  }

  return errors
}

class ViewContent extends Component {
  render () {
    const { form } = this.props
    return (
      <div>
        <Grid>
          <Cell desktopSize={3} tabletSize={8} phoneSize={8}>
            <Field
              id={`${form}-current-password`}
              name='currentPassword'
              label='Current password'
              component={TextField}
              type='password'
              validate={[ required, minLength6, maxLength50 ]}
              required
            />
          </Cell>
        </Grid>
        <Grid>
          <Cell desktopSize={3} tabletSize={8} phoneSize={8}>
            <Field
              id={`${form}-new-password`}
              name='newPassword'
              label='New password'
              component={TextField}
              type='password'
              validate={[ required, minLength6, maxLength50 ]}
              required
            />
          </Cell>
          <Cell desktopSize={3} tabletSize={8} phoneSize={8}>
            <Field
              id={`${form}-confirm-new-password`}
              name='confirmNewPassword'
              label='Confirm New password'
              component={TextField}
              type='password'
              validate={[ required, minLength6, maxLength50 ]}
              required
            />
          </Cell>
        </Grid>
      </div>
    )
  }
}

export default reduxForm({
  validate,
  form: 'edit-password',
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})(ViewContent)



// WEBPACK FOOTER //
// ./src/containers/User/EditPasswordView/ViewContent/index.js